<a href="javascript:;" (click)="close()" class="close-btn"><i class="far fa-times"></i></a>
<div class="modal-body bg-none d-flex flex-column align-items-center m-0 px-5 py-4 gap-3">
  <img src="/assets/images/messaging/instagram-chat.webp" alt="" style="width: 15rem" />
  <h5 class="mb-0" i18n>Connect Instagram for Free Guest Messaging!</h5>
  <p class="mb-0" i18n>
    Engage with guests seamlessly! Integrate Instagram messaging into your Unified Inbox and start managing
    conversations for free. Track messages, automate responses, and streamline communication—all in one place.
  </p>
  <div class="w-50">
    <button class="btn btn-secondary w-100" (click)="onConnect()">
      <i class="fab fa-instagram text-xxl"></i> <ng-container i18n>Connect Instagram Now</ng-container>
    </button>
  </div>
  <div class="text-muted text-sm" i18n>100% Free - No Subscription, No Hidden Fees!</div>
</div>
